import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["className", "prefixCls", "inputPrefixCls", "size", "visibilityToggle"];
import { IconHide16pxRegular, IconInvisible16pxRegular } from "@pionex-web-kit/icons";
import classNames from "classnames";
import React, { useState } from "react";
import { getPrefixCls } from "../config";
import omit from "../hack/rc-util/omit";
import { Input } from "./Input";
import { jsx as _jsx } from "react/jsx-runtime";
var ActionMap = {
  click: "onClick",
  hover: "onMouseOver"
};
export var Password = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var onVisibleChange = function onVisibleChange() {
    var disabled = props.disabled;
    if (disabled) {
      return;
    }
    setVisible(!visible);
  };
  var getIcon = function getIcon(prefixCls) {
    var _iconProps;
    var action = props.action,
      _props$iconRender = props.iconRender,
      iconRender = _props$iconRender === void 0 ? function () {
        return null;
      } : _props$iconRender;
    var iconTrigger = ActionMap[action] || "";
    var icon = iconRender(visible);
    var iconProps = (_iconProps = {}, _defineProperty(_iconProps, iconTrigger, onVisibleChange), _defineProperty(_iconProps, "className", "".concat(prefixCls, "-icon")), _defineProperty(_iconProps, "key", "passwordIcon"), _defineProperty(_iconProps, "onMouseDown", function onMouseDown(e) {
      // Prevent focused state lost
      // https://github.com/ant-design/ant-design/issues/15173
      e.preventDefault();
    }), _defineProperty(_iconProps, "onMouseUp", function onMouseUp(e) {
      // Prevent caret position change
      // https://github.com/ant-design/ant-design/issues/23524
      e.preventDefault();
    }), _iconProps);
    return /*#__PURE__*/React.cloneElement( /*#__PURE__*/React.isValidElement(icon) ? icon : /*#__PURE__*/_jsx("span", {
      children: icon
    }), iconProps);
  };
  var className = props.className,
    customizePrefixCls = props.prefixCls,
    customizeInputPrefixCls = props.inputPrefixCls,
    size = props.size,
    visibilityToggle = props.visibilityToggle,
    restProps = _objectWithoutProperties(props, _excluded);
  var inputPrefixCls = getPrefixCls("input");
  var prefixCls = getPrefixCls("input-password");
  var suffixIcon = visibilityToggle && getIcon(prefixCls);
  var inputClassName = classNames(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-").concat(size), !!size));
  var omittedProps = _objectSpread(_objectSpread({}, omit(restProps, ["suffix", "iconRender"])), {}, {
    htmlType: visible ? "text" : "password",
    className: inputClassName,
    prefixCls: inputPrefixCls,
    suffix: suffixIcon
  });
  if (size) {
    omittedProps.size = size;
  }
  return /*#__PURE__*/_jsx(Input, _objectSpread({
    ref: ref
  }, omittedProps));
});
Password.defaultProps = {
  action: "click",
  visibilityToggle: true,
  iconRender: function iconRender(visible) {
    return visible ? /*#__PURE__*/_jsx(IconInvisible16pxRegular, {
      size: 16
    }) : /*#__PURE__*/_jsx(IconHide16pxRegular, {
      size: 16
    });
  }
};
Password.displayName = "Password";